module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5TJZ4"))).then(() => module.bundle.root('jnagv'));